// import React, { useContext, useEffect, useState } from 'react';
// import axios from 'axios';
// import { toast } from 'react-toastify';
// import { ShopContext } from '../context/ShopContext';

// const Login = () => {
//   const { token, setToken, navigate, backendUrl } = useContext(ShopContext);
//   const [currentState, setCurrentState] = useState('Login');
//   const [name, setName] = useState('');
//   const [password, setPassword] = useState('');
//   const [mobilenumber, setMobileNumber] = useState('');
//   const [email, setEmail] = useState('');
//   const [resetEmail, setResetEmail] = useState('');
//   const [otp, setOtp] = useState('');
//   const [otpSent, setOtpSent] = useState(false);
//   const [otpVerified, setOtpVerified] = useState(false);
//   const [isOtpResendAvailable, setIsOtpResendAvailable] = useState(false);

//   const handleResendOtp = async () => {
//     try {
//       const response = await axios.post(`${backendUrl}/api/user/reset-password/send-otp`, { email: resetEmail });
//       if (response.data.success) {
//         toast.success('OTP resent successfully.');
//         setIsOtpResendAvailable(false);
//         setTimeout(() => setIsOtpResendAvailable(true), 30000); // Enable resend after 30 seconds
//       } else {
//         toast.error(response.data.message);
//       }
//     } catch (error) {
//       toast.error('Failed to resend OTP.');
//     }
//   };

//   const handleOtpTimeout = () => {
//     setTimeout(() => setIsOtpResendAvailable(true), 30000); // Enable resend after 30 seconds
//   };

//   const onSubmitHandler = async (event) => {
//     event.preventDefault();
//     try {
//       if (currentState === 'Sign Up') {
//         const response = await axios.post(`${backendUrl}/api/user/register`, { name, email, mobilenumber, password });
//         if (response.data.success) {
//           setToken(response.data.token);
//           localStorage.setItem('token', response.data.token);
//           navigate('/');
//         } else {
//           toast.error(response.data.message);
//         }
//       } else if (currentState === 'Login') {
//         const response = await axios.post(`${backendUrl}/api/user/login`, { email, password });
//         if (response.data.success) {
//           setToken(response.data.token);
//           localStorage.setItem('token', response.data.token);
//           navigate('/');
//         } else {
//           toast.error(response.data.message);
//         }
//       } else if (currentState === 'Reset Password') {
//         if (!otpSent) {
//           const response = await axios.post(`${backendUrl}/api/user/reset-password/send-otp`, { email: resetEmail });
//           if (response.data.success) {
//             toast.success('OTP sent to your email.');
//             setOtpSent(true);
//             handleOtpTimeout();
//           } else {
//             toast.error(response.data.message);
//           }
//         } else if (!otpVerified) {
//           const response = await axios.post(`${backendUrl}/api/user/reset-password/verify-otp`, { email: resetEmail, otp });
//           if (response.data.success) {
//             toast.success('OTP verified. Please reset your password.');
//             setOtpVerified(true);
//           } else {
//             toast.error(response.data.message);
//           }
//         } else {
//           const response = await axios.post(`${backendUrl}/api/user/reset-password`, { email: resetEmail, password });
//           if (response.data.success) {
//             toast.success('Password reset successfully.');
//             setCurrentState('Login');
//           } else {
//             toast.error(response.data.message);
//           }
//         }
//       }
//     } catch (error) {
//       toast.error(error.message);
//     }
//   };

//   useEffect(() => {
//     if (token) {
//       navigate('/');
//     }
//   }, [token]);

//   return (
//     <form
//       onSubmit={onSubmitHandler}
//       className="flex flex-col items-center w-[90%] sm:max-w-96 m-auto mt-14 gap-4 text-gray-800"
//     >
//       <div className="inline-flex items-center gap-2 mb-2 mt-10">
//         <p className="prata-regular text-3xl">{currentState}</p>
//         <hr className="border-none h-[1.5px] w-8 bg-gray-800" />
//       </div>
//       {currentState === 'Reset Password' ? (
//         otpSent ? (
//           otpVerified ? (
//             <input
//               onChange={(e) => setPassword(e.target.value)}
//               value={password}
//               type="password"
//               className="w-full px-3 py-2 border border-gray-800"
//               placeholder="New Password"
//               required
//             />
//           ) : (
//             <input
//               onChange={(e) => setOtp(e.target.value)}
//               value={otp}
//               type="text"
//               className="w-full px-3 py-2 border border-gray-800"
//               placeholder="Enter OTP"
//               required
//             />
//           )
//         ) : (
//           <input
//             onChange={(e) => setResetEmail(e.target.value)}
//             value={resetEmail}
//             type="email"
//             className="w-full px-3 py-2 border border-gray-800"
//             placeholder="Enter your email"
//             required
//           />
//         )
//       ) : (
//         <>
//           {currentState === 'Sign Up' && (
//             <>
//               <input
//                 onChange={(e) => setName(e.target.value)}
//                 value={name}
//                 type="text"
//                 className="w-full px-3 py-2 border border-gray-800"
//                 placeholder="Name"
//                 required
//               />
//               <input
//                 onChange={(e) => setMobileNumber(e.target.value)}
//                 value={mobilenumber}
//                 type="number"
//                 className="w-full px-3 py-2 border border-gray-800"
//                 placeholder="Mobile Number"
//                 required
//               />
//             </>
//           )}
//           <input
//             onChange={(e) => setEmail(e.target.value)}
//             value={email}
//             type="email"
//             className="w-full px-3 py-2 border border-gray-800"
//             placeholder="Email"
//             required
//           />
//           <input
//             onChange={(e) => setPassword(e.target.value)}
//             value={password}
//             type="password"
//             className="w-full px-3 py-2 border border-gray-800"
//             placeholder="Password"
//             required
//           />
//         </>
//       )}
//       <div className="w-full flex justify-between text-sm mt-[-8px]">
//         {currentState === 'Login' ? (
//           <>
//             <p className="cursor-pointer" onClick={() => setCurrentState('Reset Password')}>
//               Forgot your password?
//             </p>
//             <p onClick={() => setCurrentState('Sign Up')} className="cursor-pointer">
//               Create account
//             </p>
//           </>
//         ) : (
//           <p onClick={() => setCurrentState('Login')} className="cursor-pointer">
//             Login Here
//           </p>
//         )}
//       </div>
//       <button className="bg-black text-white font-light px-8 py-2 mt-4">
//         {currentState === 'Login'
//           ? 'Sign In'
//           : currentState === 'Sign Up'
//           ? 'Sign Up'
//           : otpSent && otpVerified
//           ? 'Reset Password'
//           : otpSent
//           ? 'Verify OTP'
//           : 'Send OTP'}
//       </button>
//       {otpSent && !otpVerified && isOtpResendAvailable && (
//         <button type="button" onClick={handleResendOtp} className="text-sm text-blue-500">
//           Resend OTP
//         </button>
//       )}
//     </form>
//   );
// };

// export default Login;


// Login.jsx
// import React, { useState, useContext, useEffect } from 'react';
// import axios from 'axios';
// import Toast from './Tost';
// import { ShopContext } from '../context/ShopContext';
// import { useNavigate } from 'react-router-dom';

// const LoginSignup = () => {
//   const { token, setToken, backendUrl,addToCart } = useContext(ShopContext);
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [isLogin, setIsLogin] = useState(true); // State to toggle between Login and Signup
//   const navigate = useNavigate();
//   const [toast, setToast] = useState(null);
//   const handleLoginSignup = async (event) => {
//     event.preventDefault();
//     try {
//       const response = await axios.post(
//         `${backendUrl}/api/user/${isLogin ? 'login' : 'signup'}`,
//         { email, password }
//       );
//       if (response.data.success) {
//         setToken(response.data.token);
//         localStorage.setItem('token', response.data.token);
//         navigate('/');
//       } else {
//         toast.error(response.data.message);
//       }
//     } catch (error) {
//       toast.error(error.message);
//     }
//   };

//   useEffect(() => {
//     if (token) { // Check if user is logged in
//       const pendingCartItem = localStorage.getItem("pendingCartItem");
      
//       if (pendingCartItem) {
//         const { itemId, size, color } = JSON.parse(pendingCartItem);
  
//         addToCart(itemId, size, color);
//         setToast("Item added to cart after login! ✅", "success");
  
//         // Remove the stored item after adding to cart
//         localStorage.removeItem("pendingCartItem");
//       }
  
//       navigate('/');  // Navigate after processing the cart item
//     }
//   }, [token]);  // Runs when token is set after login
  

//   return (
//     <div className="flex h-screen mt-10 mb-10 px-4 md:px-8 lg:px-16">
//       {/* Left side image */}
//       <div className="hidden lg:block w-1/2 bg-cover bg-center rounded-lg" style={{ backgroundImage: 'url(https://res.cloudinary.com/djqeoutoy/image/upload/v1738567985/zm5y9jyylwnonbg6o50v.png)' }}></div>

//       {/* Right side form */}
//       <div className="w-full lg:w-1/2 flex flex-col justify-center items-center p-4 bg-white rounded-lg ">
//         <div className="w-full max-w-md">
//           <h2 className="text-2xl font-bold text-center mb-6">{isLogin ? 'Login' : 'Sign Up'}</h2>

//           {/* Toggle buttons for Login/Signup */}
//           <div className="flex justify-left mb-6 w-full">
//             <button
//               onClick={() => setIsLogin(true)}
//               className={`w-24 py-2 rounded-l-md border ${isLogin ? 'bg-[#FF4902] text-white' : 'bg-gray-200 text-black'}`}
//             >
//               Login
//             </button>
//             <button
//               onClick={() => navigate('/signup')}
//               className={`w-24 py-2 rounded-r-md border ${!isLogin ? 'bg-[#FF4902] text-white' : 'bg-gray-200 text-black'}`}
//             >
//               Sign Up
//             </button>
//           </div>

//           {/* Form content */}
//           <form onSubmit={handleLoginSignup} className="space-y-4">
//             <input
//               type="email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               className="w-full p-3 border border-black rounded text-sm"
//               placeholder="Email"
//               required
//             />
//             <input
//               type="password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               className="w-full p-3 border border-black rounded text-sm"
//               placeholder="Password"
//               required
//             />

//             <button
//               type="submit"
//               className="w-full py-3 bg-[#FF4902] text-white rounded text-sm"
//             >
//               {isLogin ? 'Login' : 'Sign Up'}
//             </button>

//             {/* Divider with OR */}
//             <div className="flex items-center mb-4">
//               <hr className="w-full border-gray-300" />
//               <span className="mx-4 text-gray-500 text-sm">Or</span>
//               <hr className="w-full border-gray-300" />
//             </div>

//             <div className="mb-6 text-center">
//               <p className="text-gray-500 text-sm cursor-pointer" onClick={() => navigate('/reset-password')}>Forgot your password?</p>
//             </div>

//             {/* Social login buttons */}
//             <div className="flex mb-4 space-x-2">
//           <button
//                 className="w-full py-3 border border-black rounded text-[#FF4902] bg-white mb-2 text-sm cursor-not-allowed opacity-50"
//                 disabled
//               >
//                 Google
//               </button>
//               <button
//                 className="w-full py-3 border border-black rounded text-[#FF4902] bg-white mb-2 text-sm cursor-not-allowed opacity-50"
//                 disabled
//               >
//                 Facebook
//               </button>
//             </div>
//              {/* Signup/Login link message */}
// <div className="text-center mt-4">  
//   {isLogin ? (
//     <p className="text-sm text-gray-600">
//       Don’t have an account?{" "}
//       <span
//         onClick={() => navigate("/signup")}
//         className="text-[#FF4902] font-semibold cursor-pointer hover:underline"
//       >
//         Sign up
//       </span>
//     </p>
//   ) : (
//     <p className="text-sm text-gray-600">
//       Already have an account?{" "}
//       <span
//         onClick={() => setIsLogin(true)}
//         className="text-[#FF4902] font-semibold cursor-pointer hover:underline"
//       >
//         Login
//       </span>
//     </p>
//   )}
// </div>
//             <div className="text-center text-sm">
//               <p>
//                 By creating an account or logging in, you agree with Mammoth Streetwear®’s {' '}
//                 <span className="font-bold cursor-pointer" onClick={() => navigate('/termandc')}>Terms and Conditions</span> and{' '}
//                 <span className="font-bold cursor-pointer" onClick={() => navigate('/privacy-policy')}>Privacy Policy</span>
//               </p>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginSignup;












// import React, { useState, useContext, useEffect } from 'react';
// import axios from 'axios';
// import { toast } from 'react-toastify';
// import { ShopContext } from '../context/ShopContext';
// import { useNavigate } from 'react-router-dom';
// import { useGoogleLogin } from '@react-oauth/google'; // Import Google login hook
// import { googleAuth } from './api'; // Import googleAuth function

// const LoginSignup = () => {
//   const { token, setToken, backendUrl } = useContext(ShopContext);
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [isLogin, setIsLogin] = useState(true); // State to toggle between Login and Signup
//   const navigate = useNavigate();

//   const handleLoginSignup = async (event) => {
//     event.preventDefault();
//     try {
//       const response = await axios.post(
//         `${backendUrl}/api/user/${isLogin ? 'login' : 'signup'}`,
//         { email, password }
//       );
//       if (response.data.success) {
//         setToken(response.data.token);
//         localStorage.setItem('token', response.data.token);
//         navigate('/');
//       } else {
//         toast.error(response.data.message);
//       }
//     } catch (error) {
//       toast.error(error.message);
//     }
//   };

//   const responseGoogle = async (authResult) => {
//     try {
//       if (authResult['code']) {
//         const result = await googleAuth(authResult.code);
//         const { email, name, image } = result.data.user;
//         const token = result.data.token;
//         const obj = { email, name, token, image };
//         localStorage.setItem('user-info', JSON.stringify(obj));
//         navigate('/dashboard');
//       } else {
//         console.log(authResult);
//         throw new Error(authResult);
//       }
//     } catch (e) {
//       console.log('Error while Google Login...', e);
//     }
//   };

//   const googleLogin = useGoogleLogin({
//     onSuccess: responseGoogle,
//     onError: responseGoogle,
//     flow: 'auth-code',
//   });

//   useEffect(() => {
//     if (token) {
//       navigate('/');
//     }
//   }, [token]);

//   return (
//     <div className="flex h-screen mt-10 mb-10 px-4 md:px-8 lg:px-16">
//       {/* Left side image */}
//       <div
//         className="hidden lg:block w-1/2 bg-cover bg-center rounded-lg"
//         style={{
//           backgroundImage:
//             'url(https://images.pexels.com/photos/2007143/pexels-photo-2007143.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2)',
//         }}
//       ></div>

//       {/* Right side form */}
//       <div className="w-full lg:w-1/2 flex flex-col justify-center items-center p-4 bg-white rounded-lg ">
//         <div className="w-full max-w-md">
//           <h2 className="text-2xl font-bold text-center mb-6">
//             {isLogin ? 'Login' : 'Sign Up'}
//           </h2>

//           {/* Toggle buttons for Login/Signup */}
//           <div className="flex justify-left mb-6 w-full">
//             <button
//               onClick={() => setIsLogin(true)}
//               className={`w-24 py-2 rounded-l-md border ${isLogin ? 'bg-[#FF4902] text-white' : 'bg-gray-200 text-black'}`}
//             >
//               Login
//             </button>
//             <button
//               onClick={() => setIsLogin(false)}
//               className={`w-24 py-2 rounded-r-md border ${!isLogin ? 'bg-[#FF4902] text-white' : 'bg-gray-200 text-black'}`}
//             >
//               Sign Up
//             </button>
//           </div>

//           {/* Form content */}
//           <form onSubmit={handleLoginSignup} className="space-y-4">
//             <input
//               type="email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               className="w-full p-3 border border-black rounded text-sm"
//               placeholder="Email"
//               required
//             />
//             <input
//               type="password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               className="w-full p-3 border border-black rounded text-sm"
//               placeholder="Password"
//               required
//             />

//             <button
//               type="submit"
//               className="w-full py-3 bg-[#FF4902] text-white rounded text-sm"
//             >
//               {isLogin ? 'Login' : 'Sign Up'}
//             </button>

//             {/* Divider with OR */}
//             <div className="flex items-center mb-4">
//               <hr className="w-full border-gray-300" />
//               <span className="mx-4 text-gray-500 text-sm">Or</span>
//               <hr className="w-full border-gray-300" />
//             </div>

//             <div className="mb-6 text-center">
//               <p
//                 className="text-gray-500 text-sm cursor-pointer"
//                 onClick={() => navigate('/reset-password')}
//               >
//                 Forgot your password?
//               </p>
//             </div>

//             {/* Social login buttons */}
//             <div className="flex mb-4 space-x-2">
//               <button
//                 onClick={googleLogin}
//                 className="w-full py-3 border border-black rounded text-[#FF4902] bg-white text-sm"
//               >
//                 Continue with Google
//               </button>
//               <button
//                 className="w-full py-3 border border-black rounded text-[#FF4902] bg-white mb-2 text-sm cursor-not-allowed opacity-50"
//                 disabled
//               >
//                 Facebook
//               </button>
//             </div>

//             <div className="text-center text-sm">
//               <p>
//                 By creating an account or logging in, you agree with Mammoth Streetwear®’s{' '}
//                 <span
//                   className="font-bold cursor-pointer"
//                   onClick={() => navigate('/terms')}
//                 >
//                   Terms and Conditions
//                 </span>{' '}
//                 and{' '}
//                 <span
//                   className="font-bold cursor-pointer"
//                   onClick={() => navigate('/privacy-policy')}
//                 >
//                   Privacy Policy
//                 </span>
//               </p>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginSignup;





// import React, { useState, useContext, useEffect } from 'react';
// import axios from 'axios';
// import { toast } from 'react-toastify';
// import { ShopContext } from '../context/ShopContext';
// import { useNavigate } from 'react-router-dom';
// import { useGoogleLogin } from '@react-oauth/google';

// const LoginSignup = () => {
//   const { token, setToken, backendUrl } = useContext(ShopContext);
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [isLogin, setIsLogin] = useState(true); // State to toggle between Login and Signup
//   const navigate = useNavigate();

//   // Google login response handler
//   const responseGoogle = async (authResult) => {
//     try {
//       if (authResult?.code) {
//         const result = await axios.get(`${backendUrl}/auth/google?code=${authResult.code}`);
//         const { email, name, token } = result.data.user;
//         setToken(token);
//         localStorage.setItem('token', token);
//         navigate('/');
//       } else {
//         throw new Error('Google login failed');
//       }
//     } catch (error) {
//       toast.error('Google login failed: ' + error.message);
//     }
//   };

//   const googleLogin = useGoogleLogin({
//     onSuccess: responseGoogle,
//     onError: responseGoogle,
//     flow: 'auth-code',
//   });

//   const handleLoginSignup = async (event) => {
//     event.preventDefault();
//     try {
//       const response = await axios.post(
//         `${backendUrl}/api/user/${isLogin ? 'login' : 'signup'}`,
//         { email, password }
//       );
//       if (response.data.success) {
//         setToken(response.data.token);
//         localStorage.setItem('token', response.data.token);
//         navigate('/');
//       } else {
//         toast.error(response.data.message);
//       }
//     } catch (error) {
//       toast.error(error.message);
//     }
//   };

//   useEffect(() => {
//     if (token) {
//       navigate('/');
//     }
//   }, [token]);

//   return (
//     <div className="flex h-screen mt-10 mb-10 px-4 md:px-8 lg:px-16">
//       {/* Left side image */}
//       <div className="hidden lg:block w-1/2 bg-cover bg-center rounded-lg" style={{ backgroundImage: 'url(https://images.pexels.com/photos/2007143/pexels-photo-2007143.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2)' }}></div>

//       {/* Right side form */}
//       <div className="w-full lg:w-1/2 flex flex-col justify-center items-center p-4 bg-white rounded-lg ">
//         <div className="w-full max-w-md">
//           <h2 className="text-2xl font-bold text-center mb-6">{isLogin ? 'Login' : 'Sign Up'}</h2>

//           {/* Toggle buttons for Login/Signup */}
//           <div className="flex justify-left mb-6 w-full">
//             <button
//               onClick={() => setIsLogin(true)}
//               className={`w-24 py-2 rounded-l-md border ${isLogin ? 'bg-[#FF4902] text-white' : 'bg-gray-200 text-black'}`}
//             >
//               Login
//             </button>
//             <button
//               onClick={() => navigate('/signup')}
//               className={`w-24 py-2 rounded-r-md border ${!isLogin ? 'bg-[#FF4902] text-white' : 'bg-gray-200 text-black'}`}
//             >
//               Sign Up
//             </button>
//           </div>

//           {/* Form content */}
//           <form onSubmit={handleLoginSignup} className="space-y-4">
//             <input
//               type="email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               className="w-full p-3 border border-black rounded text-sm"
//               placeholder="Email"
//               required
//             />
//             <input
//               type="password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               className="w-full p-3 border border-black rounded text-sm"
//               placeholder="Password"
//               required
//             />

//             <button
//               type="submit"
//               className="w-full py-3 bg-[#FF4902] text-white rounded text-sm"
//             >
//               {isLogin ? 'Login' : 'Sign Up'}
//             </button>

//             {/* Divider with OR */}
//             <div className="flex items-center mb-4">
//               <hr className="w-full border-gray-300" />
//               <span className="mx-4 text-gray-500 text-sm">Or</span>
//               <hr className="w-full border-gray-300" />
//             </div>

//             <div className="mb-6 text-center">
//               <p className="text-gray-500 text-sm cursor-pointer" onClick={() => navigate('/reset-password')}>Forgot your password?</p>
//             </div>

//             {/* Social login buttons */}
//             <div className="flex mb-4 space-x-2">
//               <button
//                 onClick={googleLogin}
//                 className="w-full py-3 border border-black rounded text-[#FF4902] bg-white text-sm"
//               >
//                 Continue with Google
//               </button>
//               <button
//                 className="w-full py-3 border border-black rounded text-[#FF4902] bg-white mb-2 text-sm cursor-not-allowed opacity-50"
//                 disabled
//               >
//                 Facebook
//               </button>
//             </div>

//             <div className="text-center text-sm">
//               <p>
//                 By creating an account or logging in, you agree with Mammoth Streetwear®’s {' '}
//                 <span className="font-bold cursor-pointer" onClick={() => navigate('/terms')}>Terms and Conditions</span> and{' '}
//                 <span className="font-bold cursor-pointer" onClick={() => navigate('/privacy-policy')}>Privacy Policy</span>
//               </p>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginSignup;


// import React, { useState, useContext, useEffect } from 'react';
// import axios from 'axios';
// import { toast } from 'react-toastify';
// import { ShopContext } from '../context/ShopContext';
// import { useNavigate } from 'react-router-dom';
// import { useGoogleLogin } from '@react-oauth/google';

// const LoginSignup = () => {
//   const { token, setToken, backendUrl } = useContext(ShopContext);
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [isLogin, setIsLogin] = useState(true); // State to toggle between Login and Signup
//   const navigate = useNavigate();

//   const handleLoginSignup = async (event) => {
//     event.preventDefault();
//     try {
//       const response = await axios.post(
//         `${backendUrl}/api/user/${isLogin ? 'login' : 'signup'}`,
//         { email, password }
//       );
//       if (response.data.success) {
//         setToken(response.data.token);
//         localStorage.setItem('token', response.data.token);
//         navigate('/');
//       } else {
//         toast.error(response.data.message);
//       }
//     } catch (error) {
//       toast.error(error.message);
//     }
//   };

//   const responseGoogle = async (authResult) => {
//     try {
//       if (authResult["code"]) {
//         const result = await axios.get(`${backendUrl}/auth/google/callback?code=${authResult.code}`);
//         const { email, name, token } = result.data.user;
//         setToken(token);
//         localStorage.setItem('token', token);
//         navigate('/');
//       } else {
//         console.log(authResult);
//         throw new Error('No auth code received');
//       }
//     } catch (e) {
//       toast.error('Error while Google Login...');
//       console.error(e);
//     }
//   };

//   const googleLogin = useGoogleLogin({
//     onSuccess: responseGoogle,
//     onError: responseGoogle,
//     flow: 'auth-code',
//   });

//   useEffect(() => {
//     if (token) {
//       navigate('/');
//     }
//   }, [token]);

//   return (
//     <div className="flex h-screen mt-10 mb-10 px-4 md:px-8 lg:px-16">
//       {/* Left side image */}
//       <div className="hidden lg:block w-1/2 bg-cover bg-center rounded-lg" style={{ backgroundImage: 'url(https://images.pexels.com/photos/2007143/pexels-photo-2007143.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2)' }}></div>

//       {/* Right side form */}
//       <div className="w-full lg:w-1/2 flex flex-col justify-center items-center p-4 bg-white rounded-lg ">
//         <div className="w-full max-w-md">
//           <h2 className="text-2xl font-bold text-center mb-6">{isLogin ? 'Login' : 'Sign Up'}</h2>

//           {/* Toggle buttons for Login/Signup */}
//           <div className="flex justify-left mb-6 w-full">
//             <button
//               onClick={() => setIsLogin(true)}
//               className={`w-24 py-2 rounded-l-md border ${isLogin ? 'bg-[#FF4902] text-white' : 'bg-gray-200 text-black'}`}
//             >
//               Login
//             </button>
//             <button
//               onClick={() => navigate('/signup')}
//               className={`w-24 py-2 rounded-r-md border ${!isLogin ? 'bg-[#FF4902] text-white' : 'bg-gray-200 text-black'}`}
//             >
//               Sign Up
//             </button>
//           </div>

//           {/* Form content */}
//           <form onSubmit={handleLoginSignup} className="space-y-4">
//             <input
//               type="email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               className="w-full p-3 border border-black rounded text-sm"
//               placeholder="Email"
//               required
//             />
//             <input
//               type="password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               className="w-full p-3 border border-black rounded text-sm"
//               placeholder="Password"
//               required
//             />

//             <button
//               type="submit"
//               className="w-full py-3 bg-[#FF4902] text-white rounded text-sm"
//             >
//               {isLogin ? 'Login' : 'Sign Up'}
//             </button>

//             {/* Divider with OR */}
//             <div className="flex items-center mb-4">
//               <hr className="w-full border-gray-300" />
//               <span className="mx-4 text-gray-500 text-sm">Or</span>
//               <hr className="w-full border-gray-300" />
//             </div>

//             <div className="mb-6 text-center">
//               <p className="text-gray-500 text-sm cursor-pointer" onClick={() => navigate('/reset-password')}>Forgot your password?</p>
//             </div>

//             {/* Social login buttons */}
//             <div className="flex mb-4 space-x-2">
//               <button
//                 onClick={googleLogin}
//                 className="w-full py-3 border border-black rounded text-[#FF4902] bg-white text-sm"
//               >
//                 Continue with Google
//               </button>
//               <button
//                 className="w-full py-3 border border-black rounded text-[#FF4902] bg-white mb-2 text-sm cursor-not-allowed opacity-50"
//                 disabled
//               >
//                 Facebook
//               </button>
//             </div>

//             <div className="text-center text-sm">
//               <p>
//                 By creating an account or logging in, you agree with Mammoth Streetwear®’s {' '}
//                 <span className="font-bold cursor-pointer" onClick={() => navigate('/terms')}>Terms and Conditions</span> and{' '}
//                 <span className="font-bold cursor-pointer" onClick={() => navigate('/privacy-policy')}>Privacy Policy</span>
//               </p>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginSignup;


// import React, { useState, useContext, useEffect } from "react";
// import axios from "axios";
// import { toast } from "react-toastify";
// import Toast from './Tost';
// import { ShopContext } from "../context/ShopContext";
// import { useNavigate } from "react-router-dom";
// import { FcGoogle } from "react-icons/fc";
// const Login = () => {
//   const { token, setToken, backendUrl,addToCart } = useContext(ShopContext);
//   const navigate = useNavigate();
//   const [toast, setToast] = useState(null);
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");

//   // ✅ Normal login handler
//   const handleLogin = async (event) => {
//     event.preventDefault();
//     try {
//       const response = await axios.post(`${backendUrl}/api/user/login`, {
//         email,
//         password,
//       });

//       if (response.data.success) {
//         setToken(response.data.token);
//         localStorage.setItem("token", response.data.token);
//         navigate("/");
//       } else {
//         toast.error(response.data.message);
//       }
//     } catch (error) {
//       toast.error(error.message);
//     }
//   };

//   // ✅ Google login - same as signup
//   const handleGoogleLogin = () => {
//     window.open(`${backendUrl}/api/user/auth/google`, "_self");
//   };

//   // ✅ Check token from URL (after Google redirect)
//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const tokenFromUrl = urlParams.get("token");
//     if (tokenFromUrl) {
//       setToken(tokenFromUrl);
//       localStorage.setItem("token", tokenFromUrl);
//       navigate("/");
//     }
//   }, []);
//   useEffect(() => {
//     if (token) { // Check if user is logged in
//       const pendingCartItem = localStorage.getItem("pendingCartItem");
      
//       if (pendingCartItem) {
//         const { itemId, size, color } = JSON.parse(pendingCartItem);
  
//         addToCart(itemId, size, color);
//         setToast("Item added to cart after login! ✅", "success");
  
//         // Remove the stored item after adding to cart
//         localStorage.removeItem("pendingCartItem");
//       }
  
//       navigate('/');  // Navigate after processing the cart item
//     }
//   }, [token]);  // Runs when token is set after login

  
//   useEffect(() => {
//     if (token) {
//       navigate("/");
//     }
//   }, [token]);

//   return (
//     <div className="flex h-screen mt-10 mb-10 px-4 md:px-8 lg:px-16">
//       {/* Left side image */}
//       <div
//         className="hidden lg:block w-1/2 bg-cover bg-center rounded-lg"
//         style={{
//           backgroundImage:
//             "url(https://res.cloudinary.com/djqeoutoy/image/upload/v1738567985/zm5y9jyylwnonbg6o50v.png)",
//         }}
//       ></div>

//       {/* Right side form */}
//       <div className="w-full lg:w-1/2 flex flex-col justify-center items-center p-4 bg-white rounded-lg">
//         <div className="w-full max-w-md">
//           <h2 className="text-2xl font-bold text-center mb-6">Login</h2>

//           {/* Toggle buttons */}
//           <div className="flex justify-left mb-6 w-full">
//             <button
//               className="w-24 py-2 rounded-l-md border bg-[#FF4902] text-white"
//               disabled
//             >
//               Login
//             </button>
//             <button
//               onClick={() => navigate("/signup")}
//               className="w-24 py-2 rounded-r-md border bg-gray-200 text-black"
//             >
//               Sign Up
//             </button>
//           </div>

//           {/* Form content */}
//           <form onSubmit={handleLogin} className="space-y-4">
//             <input
//               type="email"
//               onChange={(e) => setEmail(e.target.value)}
//               value={email}
//               className="w-full p-3 border border-black rounded text-sm"
//               placeholder="Email"
//               required
//             />
//             <input
//               type="password"
//               onChange={(e) => setPassword(e.target.value)}
//               value={password}
//               className="w-full p-3 border border-black rounded text-sm"
//               placeholder="Password"
//               required
//             />

//             <button
//               type="submit"
//               className="w-full py-3 bg-[#FF4902] text-white rounded text-sm"
//             >
//               Login
//             </button>

//             {/* Divider */}
//             <div className="flex items-center mb-4">
//               <hr className="w-full border-gray-300" />
//               <span className="mx-4 text-gray-500 text-sm">Or</span>
//               <hr className="w-full border-gray-300" />
//             </div>

//             <div className="mb-6 text-center">
//               <p
//                 className="text-gray-500 text-sm cursor-pointer"
//                 onClick={() => navigate("/reset-password")}
//               >
//                 Forgot your password?
//               </p>
//             </div>

//             {/* Social login */}
//            {/* Social login */}
//            <div className="flex mb-4">
//              <button
//                onClick={handleGoogleLogin}
//                type="button"
//                className="w-full py-3 border border-black rounded flex items-center justify-center space-x-2 text-sm bg-white text-[#FF4902]"
//              >
//                <FcGoogle className="w-5 h-5" />
//                <span>Continue with Google</span>
//              </button>
//            </div>

//             <div className="text-center text-sm">
//               <p>
//                 By logging in, you agree with Mammoth Streetwear®’s{" "} 
//                 <span
//                   className="font-bold cursor-pointer"
//                   onClick={() => navigate("/terms")}
//                 >
//                   Terms and Conditions
//                 </span>{" "}
//                 and{" "}
//                 <span
//                   className="font-bold cursor-pointer"
//                   onClick={() => navigate("/privacy-policy")}
//                 >
//                   Privacy Policy
//                 </span>
//               </p>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;

import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { ShopContext } from "../context/ShopContext";
import { useNavigate } from "react-router-dom";
import { FcGoogle } from "react-icons/fc";

const Login = () => {
   useEffect(() => {
    const backendUrl = import.meta.env.VITE_BACKEND_URL; // ✅ dynamic URL
    axios.post(`${backendUrl}/api/analytics/visit`, { page: "Login" })
      .then(res => console.log(" visit recorded:", res.data))
      .catch(err => console.error("Analytics error:", err));
  }, []);

  const { token, setToken, backendUrl, addToCart } = useContext(ShopContext);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  
  // ✅ Normal login handler
  const handleLogin = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post(`${backendUrl}/api/user/login`, {
        email,
        password,
      });

      if (response.data.success) {
        localStorage.setItem("token", response.data.token);
        setToken(response.data.token);
        navigate("/");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  // ✅ Google login - same as signup
  const handleGoogleLogin = () => {
    window.open(`${backendUrl}/api/user/auth/google`, "_self");
  };

  // ✅ Check token from URL (after Google redirect)
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = urlParams.get("token");
    if (tokenFromUrl) {
      localStorage.setItem("token", tokenFromUrl);
      setToken(tokenFromUrl);
      navigate("/");
    }
  }, [navigate, setToken]);

  // ✅ Process pending cart items once token is set
  useEffect(() => {
    if (token) {
      const pendingCartItem = localStorage.getItem("pendingCartItem");

      if (pendingCartItem) {
        try {
          const { itemId, size, color } = JSON.parse(pendingCartItem);
          addToCart(itemId, size, color);
          toast.success("Item added to cart after login ✅");
          localStorage.removeItem("pendingCartItem");
        } catch (err) {
          console.error("Error restoring cart:", err);
        }
      }
    }
  }, [token, addToCart]);

  return (
    <div className="flex h-screen mt-10 mb-10 px-4 md:px-8 lg:px-16">
      {/* Left side image */}
      <div
        className="hidden lg:block w-1/2 bg-cover bg-center rounded-lg"
        style={{
          backgroundImage:
            "url(https://res.cloudinary.com/djqeoutoy/image/upload/v1738567985/zm5y9jyylwnonbg6o50v.png)",
        }}
      ></div>

      {/* Right side form */}
      <div className="w-full lg:w-1/2 flex flex-col justify-center items-center p-4 bg-white rounded-lg">
        <div className="w-full max-w-md">
          <h2 className="text-2xl font-bold text-center mb-6">Login</h2>

          {/* Toggle buttons */}
          <div className="flex justify-left mb-6 w-full">
            <button
              className="w-24 py-2 rounded-l-md border bg-[#FF4902] text-white"
              disabled
            >
              Login
            </button>
            <button
              onClick={() => navigate("/signup")}
              className="w-24 py-2 rounded-r-md border bg-gray-200 text-black"
            >
              Sign Up
            </button>
          </div>

          {/* Form content */}
          <form onSubmit={handleLogin} className="space-y-4">
            <input
              type="email"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              className="w-full p-3 border border-black rounded text-sm"
              placeholder="Email"
              required
            />
            <input
              type="password"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              className="w-full p-3 border border-black rounded text-sm"
              placeholder="Password"
              required
            />

            <button
              type="submit"
              className="w-full py-3 bg-[#FF4902] text-white rounded text-sm"
            >
              Login
            </button>

            {/* Divider */}
            <div className="flex items-center mb-4">
              <hr className="w-full border-gray-300" />
              <span className="mx-4 text-gray-500 text-sm">Or</span>
              <hr className="w-full border-gray-300" />
            </div>

            <div className="mb-6 text-center">
              <p
                className="text-gray-500 text-sm cursor-pointer"
                onClick={() => navigate("/reset-password")}
              >
                Forgot your password?
              </p>
            </div>

            {/* Social login */}
            <div className="flex mb-4">
              <button
                onClick={handleGoogleLogin}
                type="button"
                className="w-full py-3 border border-black rounded flex items-center justify-center space-x-2 text-sm bg-white text-[#FF4902]"
              >
                <FcGoogle className="w-5 h-5" />
                <span>Continue with Google</span>
              </button>
            </div>

            <div className="text-center text-sm">
              <p>
                By logging in, you agree with Mammoth Streetwear®’s{" "}
                <span
                  className="font-bold cursor-pointer"
                  onClick={() => navigate("/terms")}
                >
                  Terms and Conditions
                </span>{" "}
                and{" "}
                <span
                  className="font-bold cursor-pointer"
                  onClick={() => navigate("/privacy-policy")}
                >
                  Privacy Policy
                </span>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
